jQuery(document).ready(function() {

    jQuery(document).foundation();
    
    var socialIcons = [];
    var suppress = false;
    jQuery(document).on('click', function() {
        if (!suppress) {
            socialIcons.map(function(icon) { jQuery(icon).removeClass("is-flex-important") });
            socialIcons = [];
        }
    });
    jQuery('.social-placeholder').on('click', function() {
        var currentElement = jQuery(this).next();
        var position = socialIcons.indexOf(currentElement.get(0));
        if (position === -1) {
            socialIcons.push(currentElement.get(0));
            currentElement.addClass("is-flex-important");
        } else {
            socialIcons.splice(position, 1);
            currentElement.removeClass("is-flex-important");
        }
        suppress = true;
        setTimeout(function() { suppress = false; }, 100);

    });

});
